import request from '@/utils/request'
import { get_url_deal } from '@/utils/commons'

export function get_news_data_page(data) {
  const url = get_url_deal('news/selectNewsPage.json', data)
  return request.get(url)
}

export function get_news_introduction_page(data) {
  const url = get_url_deal('news/selectNewsIntroductionPage.json', data)
  return request.get(url)
}
